import { useQr } from './hooks/useQr'
import classes from './Qr.module.sass'
import { Modal } from '../modal/Modal'
import { IconButton } from '../iconButton/IconButton'
import barcode from '../../../assets/images/icons/barcode.svg'

type Props = {
  onChange: (value: string) => void
}

const Qr = ({ onChange }: Props) => {
  const { modalActive, setModalActive, ref, startScan } = useQr(onChange)

  return (
    <div>
      <IconButton icon={barcode} onClick={startScan} display alt="Прочитать штрих код" />

      <Modal modalActive={modalActive} setModalActive={setModalActive}>
        <div className={classes.QrContainer}>
          <video className={classes.Reader} ref={ref} />
        </div>
      </Modal>
    </div>
  )
}

export default Qr
